import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14941e43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "breadcrumbs mb-3" }
const _hoisted_2 = { class: "main-content align-items-center d-flex flex-wrap" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "text-end fs-5 flex-fill" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.crumbs, (crumb, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: crumb.title
        }, [
          (crumb.url)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: crumb.url
              }, _toDisplayString(crumb.title), 9, _hoisted_3))
            : _createCommentVNode("", true),
          (!crumb.url)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(crumb.title), 1))
            : _createCommentVNode("", true),
          (idx < _ctx.crumbs.length - 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, "  ≫  "))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.title), 1)
    ])
  ]))
}